import IconEmailSuccess from './IconEmailSuccess';

export const Icon = {
  component: IconEmailSuccess,
  props: {},
  group: 'icons',
};



// WEBPACK FOOTER //
// ./src/components/IconEmailSuccess/IconEmailSuccess.example.js